import {
  getActiveDefaultCacheMeta,
  getDefaultCacheStore,
} from '../stores/store';
import { getTagKey } from './tags';
import { remove } from './cache';
import { wrapInSentrySpan } from './sentry-support';
import { flushByTag as redisFlushByTag } from '../redis/redis-tagging';

/**
 * Flushes the whole cache.
 */
export const flush = async () => {
  await wrapInSentrySpan('Flush', async span => {
    span?.setAttributes({
      'sentry.op': 'cache.flush',
      'cache.success': true,
    });

    let cache = await getDefaultCacheStore();

    await cache.clear();
  });
};

/**
 * Flushes all entries related to given tag or tags from the cache.
 */
export const flushByTag = async (tag: string | string[]): Promise<void> => {
  const cacheMeta = await getActiveDefaultCacheMeta();

  //
  // Redis implementation for flushing
  //
  if (cacheMeta?.type === 'redis') {
    return redisFlushByTag(tag);
  }

  let tagsAsArray = typeof tag === 'string' ? [tag] : tag;

  if (tagsAsArray.length === 0) {
    return;
  }

  let tagKeys = tagsAsArray.map(tag => getTagKey(tag));

  let cache = await getDefaultCacheStore();
  let values = await Promise.all(tagKeys.map(key => cache.get<string[]>(key)));

  let keysToFlush = values.reduce<string[]>((collection, keys) => {
    if (keys === null) {
      return collection;
    }

    return [...collection, ...keys];
  }, tagKeys);

  await Promise.all(keysToFlush.map(key => remove(key)));
};
